<template>
  <Layout>
    <template #default>
      <div class="container-fluid p-0 m-0">
          <div class="row bg-Hellgrau">
          <div class="col-md-6 offset-md-1 mt-5 p-0">
           <h1>Termine</h1> 
          </div>
        </div>
        

        
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from "@/layouts/Layout";

export default {
  name: "Praxis",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    Layout,
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
